import React, { useEffect } from 'react'
import { useAppDispatch } from 'app/hooks'
import { useDashboardData, useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { useDashboardWidgetPreWork } from 'hooks/useWidgetState'
import { getMoreWidgetForDashboard } from 'features/widget/asyncThunks'
import { WidgetId } from 'features/types'
import { AudienceStreamWidget } from 'schemas/AudienceStreamWidgetSchema'
import { SocialWebStreamWidget } from 'schemas/SocialWebStreamWidgetSchema'
import { Dashboard } from 'schemas/DashboardSchema'
import { DocumentFingerprintRetrievalResult } from 'schemas/DocumentFingerprintRetrievalResultSchema'

import createDocumentSearch from './createDocumentSearch'

const DocumentSoundbiteSearchEffect = ({
  widgetId,
  fingerprintIndex,
  children
}: {
  widgetId: WidgetId
  fingerprintIndex: number
  children: React.ReactElement
}) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebStreamWidget | AudienceStreamWidget>(
    widgetId
  )
  const dashboardData = useDashboardData() as Dashboard
  const preWork = useDashboardWidgetPreWork<DocumentFingerprintRetrievalResult>(widgetId)
  const { fingerprints } = preWork[0].results![0].data

  const dispatch = useAppDispatch()

  useEffect(() => {
    const soundbiteSearch = createDocumentSearch(
      widgetSetting,
      dashboardData,
      fingerprints!,
      fingerprintIndex
    )
    // * will update when fingerprints changes won't need refreshTimestamp to trigger refresh
    dispatch(
      getMoreWidgetForDashboard({
        searches: [soundbiteSearch],
        widgetId: widgetSetting.widgetId!
      })
    )
  }, [widgetSetting, dashboardData, fingerprints, fingerprintIndex, dispatch])

  return children
}

export default DocumentSoundbiteSearchEffect
